import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ErrorHandlingService } from 'src/interceptors/error-interceptors.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

// This component handles displaying error.
// It shows a message to the user that an error occurred.
// The message can be customized by setting the errorMessage property.
// The error details can be set by the parent component.
@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit, OnDestroy {
  errorMessage: string;
  @Input() overrideErrorMessage: string;
  @Input() title = 'Oops! Page not found.';
  @Input() suggestion: string;
  errorImagePath = '/assets/error.png';
  errorImageAlt = 'Error 404: Page not found.';
  errorSubscription: Subscription;
  url = environment.production
    ? 'https://iqenergy-live.quidossoftware.co.uk'
    : environment.custom
      ? 'https://iqenergy-cstm.quidossoftware.co.uk'
      : 'https://iqenergy-dev.quidossoftware.co.uk';

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.errorMessage = params['message'];
      this.title = params['title'] || this.title;
      this.setErrorImage();
    });
  }

  ngOnDestroy(): void {
    this.errorSubscription.unsubscribe();
  }

  private setErrorImage(): void {
    switch (this.title) {
      case 'Unauthorized':
        this.errorImagePath = '/assets/error.png';
        this.errorImageAlt = 'Error 401: Unauthorized';
        break;
      case 'Forbidden':
        this.errorImagePath = '/assets/error.png';
        this.errorImageAlt = 'Error 403: Forbidden';
        break;
      case 'Internal Server Error':
        this.errorImagePath = '/assets/error.png';
        this.errorImageAlt = 'Error 500: Internal Server Error';
        break;
      default:
        this.errorImagePath = '/assets/error.png';
        this.errorImageAlt = 'Error 404: Page not found';
    }
  }
}
